import { slice } from './slice'

const queueActions = {
	...slice.actions,
}

export default queueActions
